import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, setAnalyticsCollectionEnabled } from 'firebase/analytics';
import { getPerformance, trace, initializePerformance } from 'firebase/performance';
import { errorHandler } from '../utils/errorHandler';

const firebaseConfig = {
  apiKey: "AIzaSyDuesuIZJ_tzSlR6OU0yh60NeRIwGckh8g",
  authDomain: "tarot-sitesi.firebaseapp.com",
  projectId: "tarot-sitesi",
  storageBucket: "tarot-sitesi.firebasestorage.app",
  messagingSenderId: "340431342697",
  appId: "1:340431342697:web:09da9dd609f133584726f8",
  measurementId: "G-BHE0EW573C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Storage
const storage = getStorage(app, "gs://tarot-sitesi.firebasestorage.app");

// Initialize Auth
const auth = getAuth(app);

// Initialize analytics
const analytics = getAnalytics(app);
setAnalyticsCollectionEnabled(analytics, false);

// Initialize Performance with custom settings
const perf = process.env.NODE_ENV === 'production' ? getPerformance(app) : null;
if (process.env.NODE_ENV === 'production') {
    initializePerformance(app);
}

if (perf) {
    // Özel trace ayarları
    const customTrace = trace(perf, 'custom_trace');
    customTrace.start();
    
    // Attribute değer uzunluğunu sınırla
    customTrace.putAttribute('max_length', '100');
    
    // Belirli elementleri izlemeyi devre dışı bırak
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const element = mutation.target as HTMLElement;
                if (element.classList.contains('MuiButton-root')) {
                    element.setAttribute('data-perf-ignore', 'true');
                }
            }
        });
    });

    observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
    });
}

// Export services
export { app, db, storage, auth, analytics, perf }; 